import _ from 'lodash';

import { TaskPipelineObject } from '@scale/shared/pipelinev3/lookup';

const typeToTitleMap = new Map<
  string,
  | ((obj: {
      name?: string;
      role?: string;
      email?: string;
      salesOrder?: string;
      taskId?: string;
      nodeName?: string;
      type?: string;
      pipelineV3HumanNode?: any;
    }) => string)
  | string
>([
  ['user', user => `${_.capitalize(user.role)} ${user.email}`],
  ['trainingscenario', scenario => `Scenario ${scenario.name}`],
  ['selecttable', dataset => `Nucleus Dataset ${dataset.name}`],
  ['corppermissionrole', role => `Corp Permission Role ${role.name}`],
  ['instructionitem', item => `Instruction Item ${item.name}`],
  ['project', project => `Project ${project.name}`],
  ['course', item => `Course ${item.name}`],
  ['bonus', item => `Bonus ${item.name}`],
  ['servicelevelagreement', sla => `SLA ${sla.name}`],
  ['taskpermissiongroup', group => `Permission Group ${group.name}`],
  ['adminaction', 'Admin Action'],
  ['tag', tag => `Tag ${tag.name}`],
  ['contract', contract => `Contract for Sales Order ${contract.salesOrder}`],
  ['stepfunctionexecution', 'Step function execution'],
  ['ontology', ontology => `Ontology ${ontology.name}`],
  ['workerteam', obj => `Team ${obj.name}`],
  ['workerprofile', obj => `Worker Profile ${obj.name}`],
  ['testproject', 'Test Project'],
  ['processedlidarframe', 'Processed Lidar Frame'],
  ['cdsurl', obj => `${obj.name}`],
  [
    TaskPipelineObject.TaskPipelineExecution,
    obj => `Task Pipeline Execution for Task: "${obj.taskId}"`,
  ],
  [
    TaskPipelineObject.TaskPipelineNode,
    obj =>
      obj.type === 'human'
        ? `Task Pipeline Node: "${obj.nodeName}" (${obj.pipelineV3HumanNode?._id})`
        : `Task Pipeline Node: "${obj.nodeName}"`,
  ],
  [TaskPipelineObject.TaskPipelineResource, obj => `Task Pipeline Resource: "${obj.name}"`],
  [TaskPipelineObject.TaskPipelineManualIntervention, _ => `Task Pipeline V3 Manual Intervention`],
  ['qaoperationnode', obj => `QA Operation Assignment ${_.capitalize(obj.type)}`],
  ['qaoperation', obj => `QA Operation (${_.startCase(obj.type)})`],
]);

export default function getObjectTitle(object: {
  __t: string;
  name?: string;
  role?: string;
  email?: string;
}): string {
  const type = object?.__t;
  const res = typeToTitleMap.get(type);
  let title: string;
  if (typeof res === 'function') {
    title = res(object);
  } else if (res) {
    title = res;
  } else {
    title = _.capitalize(type);
  }
  return title;
}
